module.exports = __webpack_public_path__ + "img/宋志红.60506dd8.jpg";